// extracted by mini-css-extract-plugin
export default {"Box":"PendingInvitationBanner-module__Box--rXKDK","Box_1":"PendingInvitationBanner-module__Box_1--EUuuy","Link":"PendingInvitationBanner-module__Link--IbmKE"};